// @ts-nocheck

import * as Types from '../../../graphql/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { gql } from '@apollo/client';
export type GetInitialInfoQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetInitialInfoQuery = { self?: AuthUserFragment | null };

export type AuthUserFragment = {
  uid: string;
  permissions?:
    | { [name in Types.PermissionName]: { [action in Types.PermissionAction]: Types.VerificationDecisionModel } }
    | null;
  sitePermissions?:
    | { [name in Types.PermissionName]: { [action in Types.PermissionAction]: Types.VerificationDecisionModel } }
    | null;
  person?: {
    uid: string;
    personUid?: string | null;
    userRole?: Types.UserRoleModel | null;
    tenantCode?: string | null;
    fullName?: string | null;
    title?: { value?: string | null } | null;
    name?: {
      fullName?: string | null;
      preferredFirst?: string | null;
      preferredMiddle?: string | null;
      preferredLast?: string | null;
      middle?: string | null;
      first?: string | null;
      last?: string | null;
    } | null;
    primaryOrg?: { uid: string; name?: string | null; displayName?: string | null } | null;
    managingOrgs?: Array<{ uid: string; name?: string | null; displayName?: string | null } | null> | null;
    primaryManager?: {
      personUid?: string | null;
      fullName?: string | null;
      name?: { fullName?: string | null } | null;
    } | null;
    profilePhoto?: { uid: string; signedUrl?: string | null } | null;
  } | null;
  preferences?: {
    firstHomePageLoadDone?: boolean | null;
    finishedTutorials?: Array<string | null> | null;
    dataTableColumnConfigurations?: Array<{
      columnOrder?: Array<string | null> | null;
      hiddenColumns?: Array<string | null> | null;
      columnSizing?: Record<string, number> | null;
      key?: string | null;
    } | null> | null;
    notificationChannelConfigurations?: Array<{
      channel?: Types.NotificationChannelModel | null;
      email?: string | null;
      enabled?: boolean | null;
    } | null> | null;
    homePage?: Array<{
      widgetType?: Types.WidgetTypeModel | null;
      index?: number | null;
      section?: Types.DashboardSection | null;
      layout?: {
        fixedPosition?: boolean | null;
        h?: number | null;
        maxHeight?: number | null;
        maxWidth?: number | null;
        minHeight?: number | null;
        minWidth?: number | null;
        w?: number | null;
        x?: number | null;
        y?: number | null;
      } | null;
    } | null> | null;
    dateTimeFormatConfig?: {
      use24HrTime: boolean;
      format?: Types.DateFormatModel | null;
      separator?: Types.DateSeparatorModel | null;
    } | null;
  } | null;
  proxyingUser?: { person?: { personUid?: string | null; name?: { fullName?: string | null } | null } | null } | null;
};

export const AuthUserFragmentDoc = gql`
    fragment AuthUser on UserModel {
  uid
  permissions
  person {
    uid
    personUid
    userRole
    tenantCode
    title {
      value
    }
    fullName
    name {
      fullName
      preferredFirst
      preferredMiddle
      preferredLast
      middle
      first
      last
    }
    primaryOrg {
      uid
      name
      displayName
    }
    managingOrgs {
      uid
      name
      displayName
    }
    primaryManager {
      personUid
      fullName
      name {
        fullName
      }
    }
    profilePhoto {
      uid
      signedUrl
    }
  }
  preferences {
    dataTableColumnConfigurations {
      columnOrder
      hiddenColumns
      columnSizing
      key
    }
    notificationChannelConfigurations {
      channel
      email
      enabled
    }
    firstHomePageLoadDone
    finishedTutorials
    homePage {
      widgetType
      index
      section
      layout {
        fixedPosition
        h
        maxHeight
        maxWidth
        minHeight
        minWidth
        w
        x
        y
      }
    }
    dateTimeFormatConfig {
      use24HrTime
      format
      separator
    }
  }
  sitePermissions
  proxyingUser {
    person {
      personUid
      name {
        fullName
      }
    }
  }
}
    ` as unknown as DocumentNode<AuthUserFragment, unknown>;
export const GetInitialInfoDocument = gql`
    query GetInitialInfo {
  self {
    ...AuthUser
  }
}
    ${AuthUserFragmentDoc}` as unknown as DocumentNode<GetInitialInfoQuery, GetInitialInfoQueryVariables>;
